import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ScrollToTop, WhatsAppFloat } from "@/components/Layout";
import { CertificateProvider } from "@/components/CertificateProvider";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import Catering from "@/pages/Catering";
import Gallery from "@/pages/Gallery";
// HealthyLiving is temporarily disabled pre-launch (placeholder content). Re-enable route when ready.
// import HealthyLiving from "@/pages/HealthyLiving";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <CertificateProvider>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/catering" element={<Catering />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFloat />
        </CertificateProvider>
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
